import { createContext, useEffect, useState } from "react";

export const LocationContext = createContext(undefined);

export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState(null);
  const [status, setStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [address, setAddress] = useState(""); // <-- new state for area name

  useEffect(() => {
    // Check if browser supports geolocation
    if (!("geolocation" in navigator)) {
      setErrorMessage("Geolocation is not supported in your browser.");
      return;
    }

    setStatus("Requesting location...");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setLocation({ latitude, longitude });
        setStatus("Location detected ✅");

        // Reverse geocoding using Nominatim
        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
          );
          const data = await response.json();
          console.log("=================    ", data);
          // You can pick city, town, village, or display_name
          if (data && data.address) {
            const areaName =  data.display_name;
            setAddress(areaName);
          }
        } catch (err) {
          console.error("Failed to fetch address:", err);
        }
      },
      (error) => {
        // Show a friendly message depending on error
        if (error.code === error.PERMISSION_DENIED) {
          setErrorMessage(
            "Please allow location access to see nearby posts."
          );
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          setErrorMessage("Location information is unavailable.");
        } else if (error.code === error.TIMEOUT) {
          setErrorMessage("Location request timed out. Try again.");
        } else {
          setErrorMessage("An unknown error occurred while fetching location.");
        }
        setStatus("Location not detected ❌");
      }
    );
  }, []);

  return (
    <LocationContext.Provider
      value={{ location, status, errorMessage, address }}
    >
      {children}
    </LocationContext.Provider>
  );
};
